import React, {useState} from 'react';
import PropTypes from 'prop-types';
import file from '../../../../../../common/assets/file_present-24px.svg';
import styles from "../../styles.module.scss";
import ModalCommon from "../../../../../../common/components/ModalCommon";
import {FileList} from "../FileList/FileList";


const PopupSelectOrderFile = ({
                                fileTypeID,
                                orderFileList,
                                label,
                                fileActions
                              }) => {
  const [show, setShow] = useState(false);
  const handleShow = () => {
    setShow(true);
    fileActions.getOrderFileList(fileTypeID);
  };
  const handleHide = () => setShow(false);

  return (
    <ModalCommon
      customModalTrigger={
        <div className={styles.itemUploadContainer}>
          <img src={file} alt="file"/>
          <span className={styles.itemUploadLabel}>{label}</span>
        </div>
      }
      header={label}
      customTriggerModal={{
        show,
        handleShow,
        handleHide,
      }}
    >
      <div className={styles.orderFileList}>
        <FileList
          fileList={orderFileList}
          fileActions={fileActions}
          fileTypeID={fileTypeID}
          handleCloseModal={handleHide}
          showFileTypeColumn={false}
          allowDownloadFile={false}
          allowDeleteFile={false}
          allowSelectFile={true}
        />
      </div>
    </ModalCommon>
  );
};

PopupSelectOrderFile.propTypes = {
  label: PropTypes.string,
  orderID: PropTypes.number,
  fileTypeID: PropTypes.number,
};

export default PopupSelectOrderFile;
